<div
  id="splashScreen"
  [attr.data-active]="isActive()">
  <div id="spinner">
    @if (isLogoVisible()) {
      <img
        width="50"
        id="appLogo"
        [src]="logo()"
        [alt]="appTitle() + ' logo'" />
    }
    <p-progressSpinner strokeWidth="3" />
  </div>

  <p>
    @if (getMessage(); as message) {
      {{ message | translate }}
    }
  </p>
</div>
